import _ from 'underscore';
import Promise from 'bluebird';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import { useMemo } from 'react';

const defaultDataManagementProperties = () => ({
  callback: _.identity,
  dataFetch: () => Promise.resolve(),
});

export const useDataManagement = (dataManagement, dependencies) => {
  const { dataFetch, callback } = _.defaults({}, dataManagement, defaultDataManagementProperties());
  const { data, error, loading } = useJsData(jsData => dataFetch(jsData).then(callback), dependencies);

  return useMemo(() => ({ data, error, loading }), [data, error, loading]);
};
